<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { DRIVER_OIDC } from '@/services/api'

const auth = useAuthStore()

onMounted(() => {
  auth.initialize()
  window.addEventListener('driver:carrier-required', onCarrierRequired)
})
onUnmounted(() => window.removeEventListener('driver:carrier-required', onCarrierRequired))

function onCarrierRequired() {
  void auth.requireCarrierChoice()
}
</script>

<template>
  <PToast position="top-center" :baseZIndex="9999" />
  <RouterView />
  <div v-if="DRIVER_OIDC && auth.carrierChooserOpen" class="fixed inset-0 z-[1000] flex items-center justify-center bg-secondary-900/60 px-5" role="dialog" aria-modal="true" aria-label="Choose a carrier">
    <section class="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl text-secondary-900">
      <h2 class="text-xl font-semibold">Choose a carrier</h2>
      <p class="mt-2 text-sm text-secondary-600">Select the carrier for your next inspection or mechanic record.</p>
      <div class="mt-5 space-y-2">
        <button v-for="carrier in auth.carriers" :key="carrier.carrier_id" type="button"
          :data-carrier-id="carrier.carrier_id"
          class="w-full rounded-lg border border-secondary-200 px-4 py-3 text-left hover:border-primary-600 hover:bg-primary-50"
          @click="auth.chooseCarrier(carrier.carrier_id)">
          <span class="block font-medium">{{ carrier.carrier_name }}</span>
          <span class="text-sm text-secondary-500">{{ carrier.role === 'mechanic' ? 'Mechanic' : 'Driver' }}</span>
        </button>
      </div>
    </section>
  </div>
</template>
